<script>
import moment from "@/utils/moment";

export default {
  props: {
    dateLabel: { type: String, required: true },
    timeLabel: { type: String, required: true },
    startingDate: {
      type: String,
      required: false,
      default: moment().toISOString()
    }
  },

  data: vm => ({
    date: moment(this.startingDate).format("YYYY-MM-DD"),
    formattedDate: vm.formatDate(
      moment(this.startingDate)
        .toISOString()
        .substr(0, 10)
    ),
    time: moment(this.startingDate).format("HH:mm"),
    dateMenu: false,
    timeMenu: false,
    dateTime: null
  }),

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    setDateTime(date, time) {
      this.dateTime = moment(`${date} ${time}`).toISOString();
      this.$emit("input", this.dateTime);
    },

    setTime(dateTimeISO) {
      this.time = moment(dateTimeISO).format("HH:mm");
    },

    setDate(dateTimeISO) {
      this.date = moment(dateTimeISO).format("YYYY-MM-DD");
    },

    setAllDateTimeData(dateTime) {
      this.setDate(dateTime);
      this.formattedDate = this.formatDate(this.date);
      this.setTime(dateTime);
      this.setDateTime(this.date, this.time);
    }
  },

  watch: {
    date(val) {
      this.formattedDate = this.formatDate(this.date);

      this.setDateTime(val, this.time);
    },

    time(val) {
      this.setDateTime(this.date, val);
    },

    startingDate(val) {
      this.setAllDateTimeData(val);
    }
  },
  mounted() {
    this.setAllDateTimeData(this.startingDate);
  }
};
</script>

<template>
  <v-layout
    align-center
    justify-space-between
    row
    wrap
    class="date-time-picker"
  >
    <v-flex
      md6
      xs12
      :class="{
        'pr-0': $vuetify.breakpoint.smAndDown,
        'pr-1': $vuetify.breakpoint.mdAndUp
      }"
    >
      <v-menu
        ref="dateMenu"
        v-model="dateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="formattedDate"
            @blur="date = parseDate(formattedDate)"
            :label="dateLabel"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          color="primary"
          v-model="date"
          :value="date"
          no-title
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.dateMenu.save(date)"
            >OK</v-btn
          >
        </v-date-picker>
      </v-menu>
    </v-flex>

    <v-flex
      md6
      xs12
      :class="{
        'pl-0': $vuetify.breakpoint.smAndDown,
        'pl-1': $vuetify.breakpoint.mdAndUp
      }"
    >
      <v-menu
        ref="timeMenu"
        v-model="timeMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        transition="scale-transition"
        offset-y
        max-width="260px"
        min-width="260px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field v-model="time" :label="timeLabel" readonly v-on="on" />
        </template>
        <v-time-picker
          color="primary"
          v-if="timeMenu"
          v-model="time"
          format="24hr"
          @click:minute="$refs.timeMenu.save(time)"
        />
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Forms/DateTimePicker.vue